<div class="activity" [class.videos]="onVideosPage" [class.goal]="isGoal">
  <div class="vertical-line" *ngIf="showVertLine && !onVideosPage"></div>

  <div *ngIf="timeString.length > 0" class="time"
       [class.live]="isLive" [class.offset]="!showVertLine">
    <span>{{timeString}}</span>
  </div>

  <div class="position-wrapper">
    <div class="card-wrapper">
      <div class="header">
        <img *ngIf="activityIcon" class="activity-icon" [src]="activityIcon" alt="Icon Whistle"/>
        <span class="title">{{title}}</span>
        <img *ngIf="teamImage" class="team-logo" [src]="teamImage" alt="Team Logo"/>
      </div>
      <div class="content">
        <ng-container *ngIf="videoSource">
          <youtube-video
            *ngIf="videoSource"
            [videoURL]="videoSource"
            [simpleStyling]="true"
          ></youtube-video>
        </ng-container>
        <ng-container *ngIf="!videoSource">
          <lib-image-carousel *ngIf="hasMedia()"
                              [paywall]="true"
                              [user]="userService.currentUser"
                              [videos]="videos"
                              [trackingInfo]="trackingInfo"
                              [autoStartVideo]="autoStartVideo"
                              [images]="images">
          </lib-image-carousel>
        </ng-container>
        <span [innerHTML]="text"></span>
      </div>
    </div>
  </div>
</div>
